import React, { ReactElement, useContext } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { IconProp, library } from '@fortawesome/fontawesome-svg-core'
import { Entry, EntrySaveStatus } from './Entry.d'
import { faSpinner, faExclamationTriangle, faHourglassHalf, faBan, faCheck } from '@fortawesome/free-solid-svg-icons'
import { isInterimEntry } from '../Write/helpers'
import { actionInProgress } from '../helpers/action/action'
import { getEntriesActionKey } from '../Write/actions'
import { EntryContext } from '../contexts/EntryContext'
import { EntryContextState } from '../contexts/EntryContext.d'
library.add(faSpinner, faExclamationTriangle, faHourglassHalf, faBan, faCheck)

export const entryStatus = (entry: Entry, state: EntryContextState): EntrySaveStatus | undefined =>
    entry.status === 'deleted' && !entry.saveStatus
        ? 'deleted'
        : !['saving'].includes(entry.saveStatus || 'saved') && actionInProgress(getEntriesActionKey(entry.id), state)
            ? 'refreshing'
            : entry.saveStatus

const statusDetails = (status?: EntrySaveStatus): { icon: IconProp, title: string } => {
    switch (status) {
        case 'saving':
            return { icon: 'spinner', title: 'Saving' }
        case 'failed':
            return { icon: 'exclamation-triangle', title: 'Retrying' }
        case 'conflicted':
            return { icon: 'exclamation-triangle', title: 'Conflict' }
        case 'waiting':
            return { icon: 'hourglass-half', title: 'Waiting' }
        case 'deleted':
            return { icon: 'ban', title: 'Deleted' }
        case 'deleting':
            return { icon: 'spinner', title: 'Deleting' }
        case 'refreshing':
            return { icon: 'spinner', title: 'Refreshing' }
        case 'saved':
        default:
            return { icon: 'check', title: 'Saved' }
    }
}

const EntryStatusIcons = (props: { entry: Entry }): ReactElement => {
    const { state } = useContext(EntryContext)
    if (isInterimEntry(props.entry.id) && props.entry.saveStatus === 'saved') {
        return <></>
    }
    const status = statusDetails(entryStatus(props.entry, state))
    return <div className="entry-write-status">
        {status.title}
        <FontAwesomeIcon icon={ status.icon } spin={ status.icon === 'spinner' } />
    </div>
}

export default EntryStatusIcons
